import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home'),
        meta: {
            title: '首页-五粮液永不分梨'
        }
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about'),
        redirect: '/about/group',
        children: [
            {
                path: 'group',
                name: 'group',
                component: () => import('@/views/about/group'),
                meta: {
                    title: '公司简介-关于我们-五粮液永不分梨'
                }
            },
            {
                path: 'culture',
                name: 'culture',
                component: () => import('@/views/about/culture'),
                meta: {
                    title: '企业文化-关于我们-五粮液永不分梨'
                }
            },
            {
                path: 'develop',
                name: 'develop',
                component: () => import('@/views/about/develop'),
                meta: {
                    title: '发展历程-关于我们-五粮液永不分梨'
                }
            },
            {
                path: 'honor',
                name: 'honor',
                component: ()=> import('@/views/about/honor'),
                meta: {
                    title: '资质荣誉-关于我们-五粮液永不分梨'
                }
            },
            {
                path: 'organization',
                name: 'organization',
                component: ()=> import('@/views/about/organization'),
                meta: {
                    title: '组织架构-关于我们-五粮液永不分梨'
                }
            },
            {
                path: 'environment',
                name: 'environment',
                component: ()=> import('@/views/about/environment'),
                meta: {
                    title: '园区环境-关于我们-五粮液永不分梨'
                }
            },
            {
                path: 'duty',
                name: 'duty',
                component: ()=> import('@/views/about/duty'),
                meta: {
                    title: '社会责任-关于我们-五粮液永不分梨'
                }
            },
        ]
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product'),
        meta: {
        }
    },
    {
        path: '/productdetail',
        name: 'productdetail',
        component: () => import('@/views/product/detail'),
        meta: {
        }
    },
    {
        path: '/news',
        name: 'news',
        redirect: '/news/information',
        component: ()=> import('@/views/news/index'),
        children:[
            {
                path: 'information',
                name: 'information',
                component:  () => import('@/views/news/information'),
                meta: {
                    title: '新闻动态-新闻动态-五粮液永不分梨'
                },

            },
            {
                path: 'magazine',
                name: 'magazine',
                component:  () => import('@/views/news/magazine'),
                meta: {
                    title: '品牌杂志-新闻动态-五粮液永不分梨'
                },

            },
            {
                path: 'notice',
                name: 'notice',
                component:  () => import('@/views/news/notice'),
                meta: {
                    title: '公告通知-新闻动态-五粮液永不分梨'
                },

            },
            {
                path: 'video',
                name: 'video',
                component:  () => import('@/views/news/video'),
                meta: {
                    title: '视频库-新闻动态-五粮液永不分梨'
                },

            },
            {
                path: 'industry',
                name: 'industry',
                component:  () => import('@/views/news/industry'),
                meta: {
                    title: '行业资讯-新闻动态-五粮液永不分梨'
                },

            },
            {
                path: 'group',
                name: 'group',
                component:  () => import('@/views/news/group'),
                meta: {
                    title: '新闻动态-集团资讯-新闻动态-五粮液永不分梨'
                },

            }
        ],
    },
    {
        path: '/detail',
        name: 'detail',
        component:  () => import('@/views/news/detail'),
        meta: {
        },

    },
    {
        path: '/party',
        name: 'party',
        component:  () => import('@/views/party'),
        meta: {
            title: '党群建设-五粮液永不分梨'
        },

    },
    {
        path: '/support',
        name: 'support',
        redirect: '/support/shop',
        component:  () => import('@/views/support'),
        children:[
            {
                path: 'shop',
                name: 'shop',
                component:  () => import('@/views/support/shop'),
                meta: {
                },
            },
            {
                path: 'contact',
                name: 'contact',
                component:  () => import('@/views/support/contact'),
                meta: {
                    title: '联系我们-服务支持-五粮液永不分梨'
                },

            },
            {
                path: 'security',
                name: 'security',
                component:  () => import('@/views/support/security'),
                meta: {
                },

            }
        ]

    },
    {
        path: '/join',
        name: 'join',
        component:  () => import('@/views/join'),
        meta: {
            title: '招商加盟-五粮液永不分梨'
        },

    },
    {
        path: '/search',
        name: 'search',
        component:  () => import('@/views/search'),
        meta: {
            title: '搜索-五粮液永不分梨'
        },

    },
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


router.beforeEach((to, from, next) => {
    next()
})

router.beforeResolve((to, from, next) => {
    next()

    if(to.meta.title){
        document.getElementsByTagName("title")[0].innerText = to.meta.title;
    }else {
        document.getElementsByTagName("title")[0].innerText = '五粮液永不分梨'
    }

})



export default router;

